<template>
  <div class="fixed">
    <div class="right-field">热线电话</div>
    <div class="fixed-box1">
      <div class="center-box">
        <div><img src="./../static/Phone.png" alt=""></div>
        <div class="text-center">客服热线</div>
      </div>
      <div class="phone-mesage1">
        <div class="tex">供应商管理部客服电话（注册及账号问题）：0358-7869555</div>
        <div class="tex">招投标系统客服电话（投标过程管理问题）：17732191156</div>
        <!-- <div class="tex">数字化系统运维客服电话（系统其他问题）：18235857891</div>  -->
        <div class="tex">工作时间：  8:00 -- 12:00 14:00 -- 18:00</div>
      </div>
    </div>
    <div class="fixed-box2 tp-5">
      <div class="center-box">
        <div><img src="./../static/CA.png" alt=""></div>
        <div class="text-center">山西CA热线</div>
      </div>
      <div class="phone-mesage2">
        <div class="tex">山西CA客服热线：</div>
        <div class="tex">400-653-0200</div>
      </div>
    </div>
  </div>
</template>
<script setup>

</script>
<style scoped>
.tex {
  font-size: 18px;
  color: rgba(255, 255, 255, 1);
}
.fixed {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.right-field {
  width: 48px;
  height: 56px;
  font-size: 24px;
  font-weight: 400;
  letter-spacing: 0px;
  line-height: 28px;
  color: rgba(0, 95, 46, 1);
}
.fixed-box1 {
  width: 84px;
  height: 84px;
  border-radius: 4px;
  background: rgba(0, 95, 46, 0.08);
  margin-top: 15px;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
}
.fixed-box1:hover .phone-mesage1 {
  display: flex;
  background: linear-gradient(135deg, rgba(0, 95, 46, 1) 0%, rgba(49, 133, 58, 1) 100%);
  
}
.fixed-box2:hover .phone-mesage2 {
  display: flex;
  background: linear-gradient(135deg, rgba(0, 95, 46, 1) 0%, rgba(49, 133, 58, 1) 100%);
}
.fixed-box2 {
  width: 84px;
  height: 84px;
  border-radius: 4px;
  background: rgba(0, 95, 46, 0.08);
  margin-top: 15px;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
}
.center-box {
  width: 74px;
  height: 74px;
  border-radius: 4px;
  background: linear-gradient(
    135deg,
    rgba(0, 95, 46, 1) 0%,
    rgba(49, 133, 58, 1) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #fff;
  cursor: pointer;
}
.center-box img {
  width: 30px;
  height: 30px;
}
.tp-5 {
  margin-top: 5px !important;
}
.text-center {
  font-size: 14px;
  color: rgba(255, 255, 255, 1);
  white-space: nowrap;
}
.phone-mesage1 {
  width: 500px;
  height: 140px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  display: none;
  position: absolute;
  top: 5px;
  left: -520px;
  border-radius: 4px;
  padding: 3px 10px;
}
.phone-mesage2 {
  width: 175px;
  height: 64px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-evenly;
  display: none;
  position: absolute;
  top: 5px;
  left: -195px;
  border-radius: 4px;
  padding: 3px 10px;
}
</style>
